import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import * as Actions from '../../redux/actions/';
import './impersonation-user-status.scss';
import { FaStopCircle } from 'react-icons/fa';

export const ImpersonationUserStatus = ({impersonationUser, setImpersonationUser}) => {
	function handleStopImpersonation () {
		setImpersonationUser(null);
	}

	return (
		<>
		{ impersonationUser ?
			<section className="impersonation-user-status">
				{ impersonationUser && impersonationUser.photoURL &&
				<div className="impersonation-user-photo">
					<img src={impersonationUser.photoURL} alt="" />
				</div>
				}
				<div className="impersonation-user-message">You are impersonating {impersonationUser.name}. All edits will be made using the impersonated user. <button className="btn" onClick={handleStopImpersonation}><FaStopCircle />Stop Impersonation</button></div>
			</section>
			: null
		}
		</>
	);
}

ImpersonationUserStatus.propTypes = {
	impersonationUser: PropTypes.object
};

const mapStateToProps = state => {
	return {
		impersonationUser: state.impersonationUser
  }
}

const mapDispatchToProps = {
	setImpersonationUser: Actions.setImpersonationUser
};

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonationUserStatus);
